import { element, isDefined } from 'angular';

export let CsvImportDirective = () => ({
  restrict: 'E',
  transclude: true,
  replace: true,
  scope: {
    content: '=?',
    header: '=?',
    headerVisible: '=?',
    separator: '=?',
    separatorVisible: '=?',
    result: '=?',
    encoding: '=?',
    encodingVisible: '=?',
    accept: '=?',
    acceptSizeExceedCallback: '=?',
    callback: '=?',
    mdButtonClass: '@?',
    mdInputClass: '@?',
    mdButtonTitle: '@?',
    mdSvgIcon: '@?',
    uploadButtonLabel: '=',
  },
  template: (_, attrs) => {
    let material = isDefined(attrs.material);
    let multiple = isDefined(attrs.multiple);
    return (
      '<div class="cng-csv-import">' +
      '<div ng-show="headerVisible"><div class="label">Header</div>' +
      (material
        ? '<input type="checkbox" ng-model="header">'
        : '<md-switch class="cng-csv-import-header-switch" ng-model="header"></md-switch>') +
      '</div>' +
      '<div ng-show="encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div>' +
      '<div ng-show="separatorVisible">' +
      '<div class="label">Seperator</div>' +
      '<span><input class="separator-input ' +
      (material ? '_md md-input' : '') +
      ' " type="text" ng-change="changeSeparator" ng-model="separator"><span>' +
      '</div>' +
      '<div>' +
      '<input class="btn" style="border:none" upload-button-label="{{uploadButtonLabel}}" type="file" ' +
      (multiple ? 'multiple' : '') +
      ' accept="{{accept}}"/>' +
      (material
        ? '<md-button ng-click="onClick($event)" class="_md md-button {{mdButtonClass}}"><md-icon md-svg-icon="{{mdSvgIcon}}"></md-icon> {{mdButtonTitle}}</md-button><md-input-container style="margin:0;"><input type="text" class="_md md-input-readable md-input {{mdInputClass}}" ng-click="onClick($event)" ng-model="filename"></md-input-container>'
        : '') +
      '</div>' +
      '</div>'
    );
  },
  link: (scope, e, attrs) => {
    scope.separatorVisible = !!scope.separatorVisible;
    scope.headerVisible = !!scope.headerVisible;
    scope.material = isDefined(attrs.material);
    scope.multiple = isDefined(attrs.multiple);
    if (scope.multiple) {
      throw new Error('Multiple attribute is not supported yet.');
    }
    let input = element(e[0].querySelector('input[type="file"]'));
    let inputContainer = element(e[0].querySelector('md-input-container'));

    if (scope.material && input) {
      input.removeClass('ng-show');
      input.addClass('ng-hide');
      if (inputContainer) {
        const container = inputContainer[0].querySelector('div.md-errors-spacer');
        if (container) {
          let errorSpacer = element();
          if (errorSpacer) {
            errorSpacer.remove();
          }
        }
      }
      scope.onClick = () => {
        input.click();
      };
    }

    element(e[0].querySelector('.separator-input')).on('keyup', el => {
      if (scope.content != null) {
        let content = {
          csv: scope.content,
          header: scope.header,
          separator: el.target['value'],
          encoding: scope.encoding,
        };
        scope.result = csvToJSON(content);
        scope.$apply();
        if (typeof scope.callback === 'function') {
          scope.callback(el);
        }
      }
    });

    e.on('change', onChangeEvent => {
      if (!onChangeEvent.target.files.length) {
        return;
      }

      scope.filename = onChangeEvent.target.files[0].name;
      let reader = new FileReader();
      reader.onload = onLoadEvent => {
        scope.$apply(() => {
          const target = onLoadEvent.target;
          const result = (target && (target['result'] as string)) || '';
          let content = {
            csv: result.replace(/\r\n|\r/g, '\n'),
            header: scope.header,
            separator: scope.separator,
          };
          scope.content = content.csv;
          scope.result = csvToJSON(content);
          scope.result.filename = scope.filename;
          scope.$$postDigest(() => {
            if (typeof scope.callback === 'function') {
              scope.callback(onChangeEvent);
            }
          });
        });
      };

      if (onChangeEvent.target.type === 'file' && (onChangeEvent.target.files != null || onChangeEvent.srcElement.files != null)) {
        reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0], scope.encoding);
      } else {
        if (scope.content != null) {
          let content = {
            csv: scope.content,
            header: !scope.header,
            separator: scope.separator,
          };
          scope.result = csvToJSON(content);
          scope.$$postDigest(() => {
            if (typeof scope.callback === 'function') {
              scope.callback(onChangeEvent);
            }
          });
        }
      }
    });

    let csvToJSON = content => {
      let lines = content.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*") {2})*[^"]*$)'));
      let result: any[] = [];
      let start = 0;
      let columnCount = lines[0].split(content.separator).length;

      let headers = [];
      if (content.header) {
        headers = lines[0].split(content.separator);
        start = 1;
      }

      for (let i = start; i < lines.length; i++) {
        let obj: any = {};
        let currentline = lines[i].split(new RegExp(content.separator + '(?![^"]*"(?:(?:[^"]*") {2})*[^"]*$)'));
        if (currentline.length === columnCount) {
          if (content.header) {
            for (let j = 0; j < headers.length; j++) {
              obj[headers[j]] = cleanCsvValue(currentline[j]);
            }
          } else {
            for (let k = 0; k < currentline.length; k++) {
              obj[k] = cleanCsvValue(currentline[k]);
            }
          }
          result.push(obj);
        }
      }
      return result;
    };

    let cleanCsvValue = value =>
      value
        .replace(/^\s*|\s*$/g, '') // remove leading & trailing space
        .replace(/^"|"$/g, '') // remove " on the beginning and end
        .replace(/""/g, '"'); // replace "" with ";
  },
});

export default 'cngCsvImport';
